import { createContext } from "react";

const OrgPlanContext = createContext({});

export default OrgPlanContext;
